<era-panel>
  <div class="d-flex flex-column flex-md-row h-100">
    <div class="w-100">
      <era-panel>
        <era-panel-header>
          @if (isEditing) {
            <h5 class="small-caps m-2">OS updates to allow</h5>
          }
        </era-panel-header>

        <era-os-update-list [class.pe-2]="isEditing"
                            [osupdates]="locationAllowedOsUpdates()"
                            [isEditing]="isEditing"
                            [allowEditing]="true"
                            (deleted)="deleted($event)">
        </era-os-update-list>
      </era-panel>
    </div>

    @if (isEditing) {
      <div class="w-100">
        <era-panel>
          <era-panel-header>
            <h5 class="small-caps m-2">Available OS updates</h5>
          </era-panel-header>
          <era-os-update-list [osupdates]="availableOsUpdates()"
                              [allowSelecting]="true"
                              (selectedOsUpdateChange)="select($event)">
          </era-os-update-list>
        </era-panel>
      </div>
    }
  </div>

  <era-panel-footer>
    @if (!isEditing) {
      <button class="btn btn-outline-primary m-2"
              (click)="edit()">
        <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
      </button>
    } @else {
      <button class="btn btn-primary float-left m-2"
              (click)="save()">Save</button>
      <button class="btn btn-success float-end m-2"
              (click)="addSelected()">Add selected</button>
    }
  </era-panel-footer>
</era-panel>